module.exports = __webpack_public_path__ + "static/01-c79dea0eddc74224132b07eb97e4a358.jpg";